import { Avatar } from "@mui/material";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { convertToLetters } from "utils/convertToLetters";
import PersonClientButtons from "components/PersonClientButtons";
import ClientEditData from "components/ClientEditData";
import TagBadge from "components/TagBadge";

const PersonClient: FC<Props> = ({ client }) => {
  return (
    <div className={styles.wrapper}>
      <Avatar className={styles.avatar}>
        {convertToLetters(
          (client?.Name ?? "").replaceAll("<em>", "").replaceAll("</em>", "")
        )}
      </Avatar>

      <div className={styles.information}>
        <div className={styles.name}>
          {(client?.Name ?? "").replaceAll("<em>", "").replaceAll("</em>", "")}
        </div>
        <div className={styles.tags}>
          {client?.Tags &&
            client.Tags.map((t) => <TagBadge tag={t}></TagBadge>)}
        </div>
        <div className={styles.buttons}>
          <PersonClientButtons client={client} />
        </div>
        <div className={styles.list}>
          <ClientEditData client={client} />
        </div>
      </div>
    </div>
  );
};

export default PersonClient;
